import { t } from 'i18next';
import { Dispatch, SetStateAction } from 'react';

import { ActionButtonType } from 'core/enums';
import { IConfirmation, ISelectionAction, ITableAction } from 'core/types';
import { PricingHelper } from 'pricing/helpers';
import { QuoteEntityType, QuoteVersionType } from 'quotes/enums';
import { ICustomerQuotePart } from 'quotes/types';
import { Color, Variant } from 'theme/enums';

import { getTotalAmountWarning } from './Actions/SubmitCustomerOrder';

export const getOrderActionItem = (
  parts: ICustomerQuotePart[],
  currentQuoteVersion: QuoteVersionType,
  minimumOrderThreshold: number,
  setConfirmationOption: Dispatch<SetStateAction<IConfirmation>>,
  onConfirm: () => void,
  onCancel: () => void,
  quoteEntityType: QuoteEntityType,
  isSelectionAction = false
): ITableAction | ISelectionAction => {
  // If at least one part from the list is not 'No Quote' or not 'Deleted',
  // order is enabled.
  const isOrderEnabled =
    QuoteVersionType.RELEASE === currentQuoteVersion &&
    parts?.some((part: ICustomerQuotePart) => !part.noQuote && !part.deleted);

  const hasTotalAmountWarning = getTotalAmountWarning(minimumOrderThreshold, parts);

  let totalAmountWarningConfirmation = null;

  if (hasTotalAmountWarning) {
    totalAmountWarningConfirmation = {
      title: t('titleWarning'),
      message: t('messageConfirmOrderTotalAmountBelowMinimum', {
        minimum: PricingHelper.formatPricing({ amount: minimumOrderThreshold }),
      }),
      confirmBtnColor: Color.SUCCESS,
      onConfirm: () => onConfirm(),
      onCancel,
    };
  }

  return {
    type: ActionButtonType.BUTTON,
    label: isSelectionAction ? t('buttonLabelOrder') : t('buttonLabelOrderAll'),
    variant: !isOrderEnabled ? Variant.OUTLINED : Variant.SOLID,
    color: Color.SUCCESS,
    onClick: () =>
      totalAmountWarningConfirmation
        ? setConfirmationOption(totalAmountWarningConfirmation)
        : onConfirm(),
    disabled: !isOrderEnabled,
    hide:
      QuoteVersionType.DRAFT === currentQuoteVersion || QuoteEntityType.QUOTE !== quoteEntityType,
  };
};
